
import { defineComponent, onBeforeMount, PropType, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// classes
import { DataState } from '@/core/classes/DataState.class'

// types
import { DispatcherCourierT } from '@/core/types/couriers.types'

// realisations
import { couriers } from '@/core/realisations/couriers.realisation'

// validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// realisations
import { dispatcher } from '@/core/realisations/dispatcher.realisation'

export default defineComponent({
    components: {
        modal: Modal,
        'the-select': TheSelect,
    },
    props: {
        checkedOrdersIds: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
        dispatcherSectorId: {
            type: Number,
            default: null,
        },
    },
    emits: ['cancel', 'submited'],
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,
            courier: null as number | null,
        })

        const state_form$ = useVuelidate({ courier: { required } }, state)

        const emitCancel = () => {
            emit('cancel')
        }

        const emitSubmited = () => {
            emit('submited')
        }

        const data_state = reactive({
            couriers: new DataState<DispatcherCourierT>({}),
        })

        const loadCouriers = async (page: number, search?: string) => {
            data_state.couriers.pagination.current_page = page

            try {
                data_state.couriers.is_loading = true

                const response = await couriers.getList({
                    page,
                    name: search,
                    dispatcherSectorIds: [props.dispatcherSectorId],
                    statusIds: [2],
                })

                data_state.couriers.list = response.data
                data_state.couriers.pagination.total_pages = response.meta.last_page

                data_state.couriers.is_failed = false
                data_state.couriers.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.couriers.failure.catchError(error)

                if (!data_state.couriers.failure.error_state.is_cancel) {
                    data_state.couriers.is_failed = true
                }
            } finally {
                if (!data_state.couriers.failure.error_state.is_cancel) {
                    data_state.couriers.is_loading = false
                }
            }
        }

        const loadMoreCouriers = async (page: number) => {
            if (page > data_state.couriers.pagination.total_pages) return
            data_state.couriers.pagination.current_page = page

            try {
                data_state.couriers.is_loading = true

                const response = await couriers.getList({
                    page,
                    dispatcherSectorIds: [props.dispatcherSectorId],
                    statusIds: [2],
                })

                data_state.couriers.list = data_state.couriers.list.concat(response.data)
                data_state.couriers.pagination.total_pages = response.meta.last_page

                data_state.couriers.is_failed = false
                data_state.couriers.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.couriers.failure.catchError(error)

                if (!data_state.couriers.failure.error_state.is_cancel) {
                    data_state.couriers.is_failed = true
                }
            } finally {
                if (!data_state.couriers.failure.error_state.is_cancel) {
                    data_state.couriers.is_loading = false
                }
            }
        }

        const searchCourier = async (search_query: string) => {
            // data_state.countries.pagination.current_page
            loadCouriers(1, search_query)
        }

        const unshiftFindedCourier = async (courier: DispatcherCourierT) => {
            await loadCouriers(data_state.couriers.pagination.current_page)
            data_state.couriers.list.unshift(courier)
        }

        onBeforeMount(() => {
            loadCouriers(1)
        })

        const submitOrder = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            if (!state.courier || !props.checkedOrdersIds.length) return

            try {
                state.is_loading = true

                await dispatcher.submitCheckedOrders({
                    order_ids: props.checkedOrdersIds,
                    courier_id: state.courier,
                })

                emitSubmited()
            } catch (error) {
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            state_form$,
            data_state,
            loadCouriers,
            emitCancel,
            emitSubmited,
            submitOrder,
            loadMoreCouriers,
            searchCourier,
            unshiftFindedCourier,
        }
    },
})
